import DOMPurify from 'dompurify';

export default {
	install: (Vue) => {
		Vue.prototype.$sanitize = (html, config = {}) => {
			return DOMPurify.sanitize(html, { ADD_ATTR: ['target'], ...config });
		};
	}
};
